import { createSelector } from "reselect";

import { getLegCards } from "./get-leg-cards";
import {
  getSegmentsFromTripLeg,
  getSearchedLeg
} from "../../../../helpers/udm";
import {
  getTrips,
  getTripsSegments,
  getAmenitiesFilter,
  getSearch
} from "../state-accessors";

export const getFilteredLegCardIdsByAmenities = createSelector(
  [getLegCards, getTrips, getTripsSegments, getAmenitiesFilter, getSearch],
  (leg_cards, trips, segments, amenities, search) => {
    const leg_card_ids = Object.keys(leg_cards);

    if (!amenities || !amenities.length) {
      return leg_card_ids;
    }

    return leg_card_ids.filter(id => {
      // @ts-expect-error TS2532 Unsafe indexed access (noUncheckedIndexedAccess); tracked in #24591
      const trip = trips[leg_cards[id][0]];
      const leg = getSearchedLeg(search, trip);
      const trip_segments = getSegmentsFromTripLeg(leg, segments);

      if (
        amenities.every(amenity =>
          trip_segments.every(({ vehicle }) =>
            vehicle.amenities?.includes(amenity)
          )
        )
      ) {
        return true;
      }

      return false;
    });
  }
);
